/* atc-hardened.js
   Extraído de snippets/product-card.liquid em 13/mai/2026.
   Antes: ~160 linhas <script> inline renderizadas N× por card em listings.
   Agora: 1× cacheado no CDN, carregado com defer.

   Intercepta submits de qualquer .js-product-form, faz add-to-cart via fetch,
   hidrata cart-drawer/cart-icon-bubble via Section Rendering API e abre o minicart.
*/
(function () {
  if (window.__ATC_HARDENED__) return;
  window.__ATC_HARDENED__ = true;

  // Seções que existem neste tema (sections/cart-drawer.liquid + cart-icon-bubble.liquid).
  // 'mini-cart' e 'cart-notification' não existem aqui — a API ignoraria de qualquer forma.
  const SECTION_IDS = ['cart-drawer','cart-icon-bubble'];

  // --- util: abre o minicart do tema ---
  function openMiniCart() {
    // gatilhos comuns
    const triggers = document.querySelectorAll(
      '[data-cart-trigger],[data-open-cart],.js-open-cart,[aria-controls="CartDrawer"],[data-action="open-mini-cart"]'
    );
    if (triggers.length) { triggers[0].click(); return; }

    // web components / drawers frequentes
    const drawer = document.querySelector(
      'cart-drawer, minicart-drawer, cart-notification, .mini-cart, #MiniCartDrawer, [data-mini-cart]'
    );
    if (!drawer) return;
    if (typeof drawer.open === 'function') drawer.open();
    drawer.classList.add('is-open','active','open');
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden','false');
  }

  // --- util: injeta HTML do drawer onde quer que o tema espere ---
  function hydrateCartUI(sectionId, html) {
    if (!html) return false;

    // Caso especial: cart-icon-bubble não é uma section wrapper própria — é um
    // <div id="cart-icon-bubble"> dentro do header. Substituir innerHTML direto.
    if (sectionId === 'cart-icon-bubble') {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        bubble.innerHTML = html;
        return true;
      }
    }

    // cria um DOM temporário com o HTML que veio da Section Rendering API
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    // 1) Caminho padrão: substituir a seção inteira (#shopify-section-<id>)
    const freshSection = tmp.querySelector('#shopify-section-' + sectionId);
    const liveSection  = document.getElementById('shopify-section-' + sectionId);
    if (freshSection && liveSection) {
      liveSection.replaceWith(freshSection);
      return true;
    }

    // 2) Fallback p/ o custom element <cart-drawer> deste tema (caso o caminho
    //    #shopify-section-* não case — ex.: a API retornar a section sem o wrapper)
    const pairs = [
      ['cart-drawer', 'cart-drawer']
    ];

    for (const [selectorLive, selectorFresh] of pairs) {
      const live = document.querySelector(selectorLive);
      const fresh = tmp.querySelector(selectorFresh);
      if (live && fresh) {
        live.innerHTML = fresh.innerHTML;
        return true;
      }
    }

    // 3) Fallback: algumas lojas usam data-section-id
    const liveByData  = document.querySelector('[data-section-id="'+sectionId+'"]');
    const freshByData = tmp.querySelector('[data-section-id="'+sectionId+'"]');
    if (liveByData && freshByData) {
      liveByData.innerHTML = freshByData.innerHTML;
      return true;
    }

    return false;
  }

  // --- util: sincroniza o input hidden "id" com o Size selecionado ---
  function syncVariantId(form) {
    // seu HTML coloca um <input.hidden.variant_id_by_checked> dentro do label do chip selecionado
    const checked = form.querySelector('.option-selector__btns .opt-btn:checked');
    const hiddenId = checked?.closest('label')?.querySelector('.variant_id_by_checked')?.value;
    let idInput = form.querySelector('input[name="id"]');
    if (!idInput) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      form.appendChild(idInput);
    }
    if (hiddenId) idInput.value = hiddenId;
  }

  // --- helpers de loading state (Bug 2 fix, 18/mai/2026) ---
  // Feedback visual otimista: abre drawer + adiciona spinner ANTES do fetch,
  // para que o cliente perceba a ação em ~10ms em vez de esperar 300-800ms.
  function setLoadingState(form, isLoading) {
    // Botão ATC do card: classe `is-adding` para CSS animar
    const btn = form.querySelector('button[type="submit"][name="add"]');
    if (btn) {
      btn.classList.toggle('is-adding', isLoading);
      btn.disabled = isLoading;
    }
    // Cart drawer: classe `cart-loading` para overlay/spinner via CSS
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('cart-loading', isLoading);
  }

  // --- intercepta todos os forms de produto do grid ---
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.matches('.js-product-form')) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    // 1) garante o variant id correto
    syncVariantId(form);

    // 2) FEEDBACK OTIMISTA: abre drawer + mostra loading IMEDIATAMENTE
    //    (antes do fetch, para feedback visual em ~10ms em vez de esperar a rede)
    setLoadingState(form, true);
    openMiniCart();

    // 3) monta payload de add-to-cart
    const fd = new FormData(form);
    fd.delete('return_to'); // evita redirects
    fd.append('sections', SECTION_IDS.join(','));
    fd.append('sections_url', window.location.pathname);

    let data;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      });

      if (!res.ok) {
        let errMsg = 'Could not add to cart';
        try {
          const err = await res.json();
          if (err && err.description) errMsg = err.description;
        } catch(_) {}
        throw new Error(errMsg);
      }

      // /cart/add.js pode devolver {id:..., sections:{...}} quando pedimos "sections"
      try { data = await res.json(); } catch(_) { data = {}; }

      // 4) se não veio "sections", busca via Section Rendering API
      if (!data || !data.sections) {
        const q = new URLSearchParams({ sections: SECTION_IDS.join(',') });
        const secRes = await fetch('/?' + q.toString(), { headers: { 'Accept': 'application/json' } });
        data = { sections: secRes.ok ? await secRes.json() : {} };
      }

      // 5) injeta cada seção que tivermos conseguido renderizar
      if (data.sections) {
        Object.entries(data.sections).forEach(([id, html]) => {
          try { hydrateCartUI(id, html); } catch(err) { console.warn('hydrate fail for', id, err); }
        });
      }

      // 6) dispara eventos que muitos temas escutam
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.body.classList.add('cart-has-items');

      // 7) remove loading state (drawer já está hidratado e aberto)
      setLoadingState(form, false);

    } catch (err) {
      console.error('Add to cart error:', err);
      // Remove loading e mostra erro
      setLoadingState(form, false);
      const box = form.querySelector('.js-form-error');
      if (box) { box.textContent = err.message || 'Error adding to cart'; box.hidden = false; }
      // Mostra mensagem de erro também no body para visibilidade (caso o card esteja fora da viewport após drawer abrir)
      document.dispatchEvent(new CustomEvent('cart:add:error', {
        bubbles: true,
        detail: { error: err.message || 'Error adding to cart' }
      }));
    }
  }, true);
})();
